export default class ObjectFitPolyfill {
  init() {
    if ('objectFit' in document.documentElement.style === false) {
      var container = document.getElementsByClassName('object-fit');

      for (var i = 0; i < container.length; i++) {
        var imageSource = '';

        if (container[i].querySelector('img').getAttribute('data-full')) {
          imageSource = container[i].querySelector('img').getAttribute('data-full');
        } else {
          imageSource = container[i].querySelector('img').src;
        }

        container[i].querySelector('img').style.display = 'none';
        container[i].style.backgroundSize = 'cover';
        container[i].style.backgroundImage = 'url(' + imageSource + ')';
        container[i].style.backgroundPosition = 'center center';
        container[i].style.backgroundRepeat = 'no-repeat';
      }
    }
  }
}